<ngx-loading-bar color="#009cc3" height="3px" includeSpinner="false" diameter="25px"></ngx-loading-bar>
<router-outlet></router-outlet>